<template>
  <div>
    <SogCard v-show="!_isShowActivationForm && _evbs.length===0">
      <SogCardContent>
        <SogFlexRow>
          Zum aktivieren der eVB, geben Sie bitte Ihre Anforderungscode ein:
        </SogFlexRow>
        <SogFlexRow>
          <SogTextBox
            ref="inputCode1"
            v-model="_code.code1"
            placeholder=""
            autocomplete="false"
            max-length="3"
            min-length="3"
            style="width: 4em"
          />
          <SogTextBox
            ref="inputCode2"
            v-model="_code.code2"
            placeholder=""
            autocomplete="false"
            max-length="3"
            min-length="3"
            style="width: 4em"
          />
          <SogTextBox
            ref="inputCode3"
            v-model="_code.code3"
            placeholder=""
            autocomplete="false"
            max-length="3"
            min-length="3"
            style="width: 4em"
          />
        </SogFlexRow>
      </SogCardContent>
      <div class="e-card-actions">
        <SogCardActionButton
          ref="btnSearch"
          mdi-icon="mdi-magnify"
          :disabled="_isActivateDisabled"
          @click="onClick"
        >
          Suchen
        </SogCardActionButton>
      </div>
      <!--
          <SogCardActions>
            <button class="e-btn">aa</button>
          </SogCardActions>
      -->
    </SogCard>
    <SogCard v-show="_isShowActivationForm">
      <SogCardTitle>eVB Aktivierung</SogCardTitle>
      <SogCardContent>
        <SogForm
          ref="formActivation"
          :validations="testValidation"
        >
          <SogFormField>
            <SogNumericTextBox
              v-model="_value.activationDuration"
              placeholder="eVB-Gültigkeit (Tage)"
              name="activationDuration"
              format="n"
            />
          </SogFormField>
          <PersonAddressForm
            ref="_personAddressForm"
            :person="_value.person"
            :address="_value.address"
          />
        </SogForm>
      </SogCardContent>
      <SogCardActions>
        <SogCardActionButton
          mdi-icon="mdi-check"
          :button-style="SogButtonStyle.Primary"
          @click="onActivationOk"
        >
          Ok
        </SogCardActionButton>
        <SogCardActionButton
          mdi-icon="mdi-cancel"
          @click="onActivationCancel"
        >
          Abbrechen
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
    <SogCard v-show="_evbs.length>0">
      <SogCardTitle>eVB</SogCardTitle>
      <SogCardContent>
        <ul>
          <li
            v-for="evb in _evbs"
            :key="evb"
          >
            {{ evb }}
          </li>
        </ul>
      </SogCardContent>
      <SogCardActions>
        <SogCardActionButton
          mdi-icon="mdi-check"
          @click="onCloseEvb"
        >
          schliessen
        </SogCardActionButton>
      </SogCardActions>
    </SogCard>
  </div>
</template>

<script setup lang="ts">
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import {onMounted, reactive, ref, watch} from "vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {useRoute} from "vue-router";
import notificationService from "@/shared/services/NotificationService";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";
import Person from "@/shared/model/person";
import PersonAddressForm from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import apiInsurance from "@/modules/Insurance/api";
import Address from "@/shared/model/Address";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";

const _code = reactive({code1:"",code2:"",code3:""})
const _isActivateDisabled = ref(true)
const _isShowActivationForm = ref(false)
const _insuranceIds = reactive<string[]>([])
const _evbs = reactive<string[]>([])
const testValidation:SogFormValidationRule[]=[
  {name:'activationDuration',rules:{required:[true,"1 bis 90 Tage"],min:1,max:90}},
]

const inputCode1 = ref<InstanceType<typeof SogTextBox>  | null>(null)
const inputCode2 = ref<InstanceType<typeof SogTextBox>  | null>(null)
const inputCode3 = ref<InstanceType<typeof SogTextBox>  | null>(null)
const btnSearch = ref<InstanceType<typeof SogButton>  | null>(null)

const formActivation = ref<InstanceType<typeof SogForm>  | null>(null)
const _personAddressForm = ref<InstanceType<typeof PersonAddressForm>  | null>(null)

const _value =  reactive({activationDuration:30,person:new Person(),address:new Address()})


const route = useRoute()



watch(
  () => route.params.code,
  () => {
    setCode(route.params.code as string)
  }
)


watch(_code,(newValue)=>{
  if(newValue.code1.length===3){
    inputCode2.value.focus()
  }
  if(newValue.code2.length===3){
    inputCode3.value.focus()
  }
  if(newValue.code3.length===3){
    btnSearch.value.focus()
  }
  _isActivateDisabled.value = _code.code1.length<3 ||_code.code2.length<3||_code.code3.length<3
})

watch([_insuranceIds],()=>{
  _isShowActivationForm.value = _insuranceIds.length>0
})

const onClick = function(){
  checkActivationCode()
}

onMounted(()=>{
  inputCode1.value?.focus()
  setCode(route.params.code as string)
})

function setCode(value:string|undefined) {
  if(value && value.length === 11 ) {
    _code.code1 = value.substring(0,3)
    _code.code2 = value.substring(4,7)
    _code.code3 = value.substring(8,11)
    checkActivationCode()
  }
}

function onActivationCancel() {
  _insuranceIds.length = 0
}

async function onActivationOk() {
  if (formActivation.value.validate() && _personAddressForm.value.validate() && _insuranceIds.length > 0) {
    const items = await apiInsurance.InsuranceActivate( _value.person,_value.address,_insuranceIds,_value.activationDuration );
    if(items && items.length>0)
      _evbs.length = 0
      items.forEach(t=>_evbs.push(t.evb??""))
      _insuranceIds.length = 0
  }

}

function onCloseEvb() {
  _evbs.length=0
  _code.code1=""
  _code.code2=""
  _code.code3=""
}

async function checkActivationCode() {
    const res = await apiInsurance.checkActivationCode(_code.code1 + ' ' + _code.code2 + ' ' + _code.code3)
    if(!res)
      return
    if (res.activated) {
      notificationService.error("eVB wurde aktiviert.")
    }
    else{
      _value.person = new Person();
      _value.address = new Address();
      _value.address.countryCode = "DE"
      _insuranceIds.push(res.id)
    }
}

</script>

<style>

</style>
